import React, { useState } from "react";
import { UserConsumer } from "../../../UserContext";
import VendorQuotationsFormList from "./VendorQuotationsFormList";
import VendorPopupModal from "./VendorPopupModal";

function VendorQuotations(props) {
	const {
		itemRequisitionId,
		categoryId,
		vendorByCategoryList,
		selectedVendor,
		setSelectedVendor,
		setVendorByCategoryList,
		onVendorChange,
		showModal,
		setShowModal,
		setIsVendorLoaded,
	} = props;

	const [editModeCategoryId, setEditModeCategoryId] = useState();
	const [unitPrice, setUnitPrice] = useState("");
	const [quantity, setQuantity] = useState("");
	const [totalCost, setTotalCost] = useState(null);
	const [description, setDescription] = useState(null);
	const [recommended, setRecommended] = useState(false);
	const [delieveryTime, setDelieveryTime] = useState(null);
	const [vendorTobeEditedId, setVendorTobeEditedId] = useState(null);
	const [isEditMode, setIsEditMode] = useState(false);

	const onUnitPriceChange = (value) => {
		setTotalCost(value * quantity);
		setUnitPrice(value);
	};
	const onQuantityChange = (value) => {
		if (unitPrice != "") setTotalCost(unitPrice * value);
		else if (quantity != "") setTotalCost(value);
		else setTotalCost(unitPrice);
		setQuantity(value);
	};
	const onEditVendorQuotations = (data) => {
		setIsEditMode(true);
		setVendorTobeEditedId(data.quotationId);
		setTotalCost(data.totalAmount);
		setDescription(data.description);
		setRecommended(data.recommended);
		if (data.deliveryTime) setDelieveryTime(new Date(data.deliveryTime));
		setUnitPrice(data.unitPrice);
		setQuantity(data.quantity);
		setEditModeCategoryId(data.categoryId);
		setSelectedVendor(data.vendor);
		setShowModal(true);
	};
	const clearFormValues = () => {
		setTotalCost("");
		setDescription("");
		setRecommended(false);
		setDelieveryTime(null);
		setUnitPrice("");
		setQuantity("");
		setSelectedVendor(null);
	};
	return (
		<UserConsumer>
			{() => {
				return (
					<>
						<VendorPopupModal
							showModal={showModal}
							isEditMode={isEditMode}
							onClose={() => {
								setIsEditMode(false);
								setShowModal(false);
								clearFormValues();
							}}
							categoryId={
								isEditMode ? editModeCategoryId : categoryId
							}
							clearFormValues={clearFormValues}
							vendorTobeEditedId={vendorTobeEditedId}
							itemRequisitionId={itemRequisitionId}
							vendorByCategoryList={vendorByCategoryList}
							setVendorByCategoryList={(value) =>
								setVendorByCategoryList(value)
							}
							selectedVendor={selectedVendor}
							setSelectedVendor={(value) =>
								setSelectedVendor(value)
							}
							onVendorChange={(value) => onVendorChange(value)}
							unitPrice={unitPrice}
							onUnitPriceChange={(value) =>
								onUnitPriceChange(value)
							}
							quantity={quantity}
							onQuantityChange={(value) =>
								onQuantityChange(value)
							}
							totalCost={totalCost}
							description={description}
							onDescriptionChange={(event) =>
								setDescription(event.target.value)
							}
							delieveryTime={delieveryTime}
							setDelieveryTime={(value) =>
								setDelieveryTime(value)
							}
							recommended={recommended}
							setRecommended={(value) => setRecommended(value)}
						/>

						<VendorQuotationsFormList
							itemRequisitionId={itemRequisitionId}
							editVendorQuotations={(data) =>
								onEditVendorQuotations(data)
							}
							setIsVendorLoaded={(value) =>
								setIsVendorLoaded(value)
							}
						/>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default VendorQuotations;
